module.exports = __webpack_public_path__ + "static/media/MLHBuild.d6cd1a99.jpg";